import React from 'react';
import withIcon from '../utilities/withIcon';

const IconToolbox = () => {
  return (
    <g>
      <path d="m6.053.001 3.901.015c.54.003.983.412 1.04.936l.006.114V3.29h4.3a.7.7 0 0 1 .694.605L16 3.99V15.3a.7.7 0 0 1-.605.694L15.3 16H.7a.7.7 0 0 1-.694-.605L0 15.3V3.99a.7.7 0 0 1 .605-.693L.7 3.29H5V1.051c0-.541.41-.987.938-1.044l.115-.006zM4 9.5H1.55v4.951h12.9V9.5H12v1.25a.75.75 0 1 1-1.5 0V9.5h-5v1.25a.75.75 0 1 1-1.5 0V9.5zM14.45 4.84H1.55V8h12.9V4.84zM6.5 1.503V3.29h3V1.514l-3-.011z" />
    </g>
  );
};

export default withIcon(IconToolbox);
